import * as React from "react";
import { Image, Button } from "react-bootstrap";
import { connect } from 'react-redux';
import './PhotoSteps.css'
import { hidePhotoStepsScreen, showFullscreenCamera } from "../../actions/fullscreenActions";
import {
    CHILLI_MONTHLY_RIGHT_CHECKMARK
} from "../../constants/copy";
import { photoData } from "../../actions/cameraActions";

class PhotoSteps extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleMileageChange = this.handleMileageChange.bind(this);
    }

    componentDidUpdate() {
        if (this.props.camera.step1RightImageUrl === CHILLI_MONTHLY_RIGHT_CHECKMARK
            && this.props.camera.step2RightImageUrl === CHILLI_MONTHLY_RIGHT_CHECKMARK
            && this.props.camera.step3RightImageUrl === CHILLI_MONTHLY_RIGHT_CHECKMARK
            && this.props.camera.canSubmitMonthlyMileage === false) {
            this.props.dispatchPhotoData({
                canSubmitMonthlyMileage: true,
            });
        }
    }

    async handleClick() {
        this.props.dispatchHidePhotoStepsScreen();
        if (this.props.profile.selfInspectionStep === 1 || this.props.profile.selfInspectionStep === 2) {
            this.props.dispatchShowFullscreenCamera();
        }
        else {
            // monthly mileage update
            await this.props.dispatchPhotoData({
                step3RightImageUrl: CHILLI_MONTHLY_RIGHT_CHECKMARK,
                step3Backround: "#fff",
            });
        }
    }

    async handleMileageChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.props.dispatchPhotoData({ [name]: value });
    }

    render() {
        let header = "";
        let bottom1 = "";
        let bottom2 = ""
        let imageUrl = "";
        let next = <div></div>
        switch (this.props.profile.selfInspectionStep) {
            case 1:
                header = "Step 1: Dashboard photo";
                bottom1 = "Take a photo of your chilli car’s dashboard";
                bottom2 = "80% of the dash needs to fit into the guidelines"
                imageUrl = "./Images/PhotoSteps/photo-step-1.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;
            case 2:
                header = "Step 2: Photo of car’s mileage";
                bottom1 = "Take a photo of your chilli car’s mileage meter (this is the meter that shows how many kms your car has ever driven)";
                bottom2 = "The whole mileage reading needs to fit into the guidelines"
                imageUrl = "./Images/PhotoSteps/photo-step-2.png";
                next = <>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick}>Got it</Button>
                </>
                break;
            case 3:
                header = "Step 3: Mileage reading";
                bottom1 = "Hint: This shows all the kms your car has ever driven ";
                bottom2 = "Enter total mileage"
                imageUrl = "./Images/PhotoSteps/photo-step-3.png";
                next = <>
                    <div className="pb-4">
                        <input type="number" className="totalMileage" id="totalMileage" name="totalMileage" onChange={this.handleMileageChange} />
                    </div>
                    <Button className="btn btn-solid-green btn-got-it" onClick={this.handleClick} disabled={this.props.camera.totalMileage === ""}>Got it</Button>
                </>
                break;
        }

        return (
            <>
                <div id="photoSteps" className="LoadingDiv p-4 text-center">
                    <h2 className="Welcome">{header}</h2>

                    <Image src={imageUrl} alt="loading" className="img-fluid gif" />
                    <div className="bottom-steps test-center ">
                        <p className="text-white mt-3">{bottom1}</p>
                        <p className="text-white">{bottom2}</p>

                        {next}
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        modal: state.modal,
        profile: state.profile,
        auth: state.auth,
        camera: state.camera,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchPhotoData: (data) => dispatch(photoData(data)),
        dispatchHidePhotoStepsScreen: () => dispatch(hidePhotoStepsScreen()),
        dispatchShowFullscreenCamera: () => dispatch(showFullscreenCamera()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PhotoSteps)